// extracted by mini-css-extract-plugin
export default {"shimmer":"CartItemsSkeleton_shimmer__AoC7i","row":"CartItemsSkeleton_row__RqKEO","name":"CartItemsSkeleton_name__Pat+3 CartItemsSkeleton_shimmer__AoC7i"};